import { ReactNode } from 'react';

type Props = {
  loading: boolean;
  hasData: boolean;
  loadingFallback?: ReactNode;
  emptyFallback?: ReactNode;
  children: ReactNode;
};

export function AsyncContent({
  loading,
  hasData,
  loadingFallback,
  emptyFallback,
  children,
}: Props) {
  if (loading) return <>{loadingFallback ?? null}</>;
  if (!hasData) return <>{emptyFallback ?? null}</>;
  return <>{children}</>;
}
